import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=cb2a6fb2&"
import script from "./OrderReview.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrderReview.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=cb2a6fb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports